const instantSearch = () => {
  instantSearchClearBtn();

  /**
   * instantSearchClearBtn
   * on mobile
   * bind instant search input clear function
   */
  function instantSearchClearBtn() {
    $('.mrQuickSearch-closeBtn').on('click', (e) => {
      e.preventDefault();
      $('#Search-In-Modal').val('');
    });
  }
};

export default instantSearch;
